import { useState } from "react";
import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Footer = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const subscribe = async (e) => {
    e.preventDefault();
    if (status === "sending") return;
    setStatus("sending");
    try {
      const res = await fetch(`${API}/newsletter`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error();
      setStatus("done");
      setEmail("");
    } catch {
      setStatus("error");
    }
  };

  return (
    <footer className="relative bg-ink text-paper" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-10">
        <div className="grid grid-cols-1 gap-10 border-b border-paper2/10 pb-10 md:grid-cols-2">
          <div>
            <Wordmark className="text-paper" markClassName="h-7 w-7 text-paper2" />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-paper2/70">
              Websites, AI tools, SEO and social for small businesses. Built
              and looked after by one developer.
            </p>
          </div>
          <div data-testid="newsletter-signup">
            <p className="font-display text-xl font-medium text-paper">
              Get one useful email a month.
            </p>
            <p className="mt-2 text-sm text-paper2/70">
              One short, practical note each month. No spam, unsubscribe anytime.
            </p>
            <form onSubmit={subscribe} className="mt-4 flex gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="newsletter-email-input"
                placeholder="you@example.com"
                required
                maxLength={200}
                className="w-full rounded-full border border-paper2/20 bg-paper/10 px-5 py-2.5 text-sm text-paper placeholder:text-paper2/40 focus:border-paper2/50"
              />
              <button
                type="submit"
                data-testid="newsletter-submit-button"
                disabled={status === "sending"}
                className="shrink-0 rounded-full bg-paper px-6 py-2.5 text-sm font-medium text-ink transition-colors duration-300 hover:bg-paper2 disabled:cursor-not-allowed disabled:opacity-60"
              >
                {status === "sending" ? "…" : "Subscribe"}
              </button>
            </form>
            <p
              role="status"
              data-testid="newsletter-status"
              className={`mt-2 text-xs ${
                status === "done" ? "text-paper2" : status === "error" ? "text-red-300" : "text-paper2/50"
              }`}
            >
              {status === "done"
                ? "You're on the list. One useful email a month."
                : status === "error"
                ? "That didn't work. Please try again."
                : "Stored safely; never shared."}
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-3 pt-8 text-sm text-paper2/70 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex flex-col gap-2 sm:items-end">
            <a
              href="mailto:groupvagus@gmail.com"
              data-testid="footer-email-link"
              className="transition-colors duration-300 hover:text-paper"
            >
              groupvagus@gmail.com
            </a>
            <p>© {new Date().getFullYear()} Vagus Digital · vagusdigital.co.uk</p>
            <Link
              to="/enquiries"
              data-testid="owner-login-link"
              className="text-xs text-paper2/40 transition-colors duration-300 hover:text-paper"
            >
              Owner
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;